import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { ProofSection } from './ProofSection';
export function Hero() {
  return <section className="grain-section relative w-full overflow-hidden bg-page-bg px-6 pb-16 pt-12 md:px-8 md:pb-24 md:pt-16" data-id="element-61" data-mp="ei1unjxvvyww">
      <div className="mx-auto w-full max-w-7xl" data-id="element-62" data-mp="4m8n6ez0uvlz">
        <div className="mx-auto max-w-4xl text-center" data-id="element-63" data-mp="4njpeactjvaz">
          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.15,
          duration: 0.7
        }} className="font-display text-lg font-bold leading-snug tracking-tight text-ink md:text-2xl" data-id="element-64" data-mp="129qtzk94hnnc">
            This May BE the BEST Opportunity You{' '}
            <span className="font-black text-teal-600 underline decoration-teal-200 decoration-4 underline-offset-4" data-id="element-65" data-mp="nekmstyajisf">
              Ever Get
            </span>{' '}
            to...
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.25,
          duration: 0.8
        }} className="mt-5 font-display text-4xl font-black leading-[1.04] tracking-tighter text-ink md:text-6xl lg:text-7xl" data-id="element-66" data-mp="384s5aonzkl32">
            Find What's{' '}
            <span className="font-black text-ink underline decoration-amber-300 decoration-[6px] underline-offset-[6px]" data-id="element-67" data-mp="3e84m18jdoqsg">
              ACTUALLY Wrong,
            </span>{' '}
            Truly Fix Your Health Issues and Finally{' '}
            <span className="font-black text-teal-600 underline decoration-teal-200 decoration-[8px] underline-offset-[7px]" data-id="element-68" data-mp="35akly2x950jf">
              GET YOUR LIFE BACK
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.35,
          duration: 0.7
        }} className="mt-8 text-base font-semibold tracking-wide text-teal-600" data-id="element-69" data-mp="2vgllr9gqnqu4">
            Dr. Ali Mazloum{' '}
            <span className="font-normal italic text-ink-light" data-id="element-70" data-mp="nbb9spq0zv12">
              ("The Human MRI")
            </span>
            <span className="mx-3 font-light text-teal-300" data-id="element-71" data-mp="ibp0ush8d0y2">|</span>
            Brenden Henry{' '}
            <span className="font-normal italic text-ink-light" data-id="element-72" data-mp="ddng8345otkh">
              ("The World's #1 Authority on Peptide Science")
            </span>
          </motion.p>

          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.45,
          duration: 0.7
        }} className="mx-auto mt-10 max-w-3xl font-display text-2xl font-bold leading-[1.35] tracking-tight text-ink md:text-3xl" data-id="element-73" data-mp="1ayjiziqkro8d">
            Get the <span data-id="element-74" data-mp="3lt75kr1phru9">MOST IMPORTANT</span> part of our life-changing
            transformation programs for a{' '}
            <span className="underline decoration-amber-300 decoration-4 underline-offset-4" data-id="element-75" data-mp="3hqalsx0fjpoq">
              FRACTION of the normal price.
            </span>
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5,
          duration: 0.7
        }} className="mt-8 flex flex-col justify-center gap-4 sm:flex-row" data-id="element-76" data-mp="21aeg18zu476x">
            <a href="#advanced-price" className="inline-flex w-full items-center justify-center gap-3 rounded-2xl bg-emerald-600 px-9 py-5 text-center text-base font-black text-white shadow-[0_12px_32px_rgba(5,150,105,0.3)] ring-1 ring-emerald-500 transition-all duration-200 hover:-translate-y-1 hover:bg-emerald-700 hover:shadow-[0_18px_42px_rgba(5,150,105,0.35)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-emerald-300/50 sm:w-auto sm:text-lg" data-id="element-77" data-mp="2fzstas6j78rl">
              Book Your Meeting With the Master: Advanced
              <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-78" data-mp="zkrbass95wd4" />
            </a>
            <a href="#masters" className="inline-flex w-full items-center justify-center rounded-2xl border-2 border-teal-600 bg-white px-8 py-5 text-center font-bold text-teal-700 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:bg-teal-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-teal-200 sm:w-auto" data-id="element-79" data-mp="4aupet2693ou">
              Meet The Masters
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55,
          duration: 0.8
        }} className="mt-12 space-y-6" data-id="element-80" data-mp="3hrbxpvsk3016">
            <p className="text-center text-lg font-medium text-ink" data-id="element-81" data-mp="3ri6kr2dmm3no">
              Whether you're:
            </p>

            <div className="grid grid-cols-1 gap-4 text-left" data-id="element-82" data-mp="2yzstxmqpjhy3">
              <div className="relative flex items-start gap-4 overflow-hidden rounded-2xl border border-black/5 bg-white p-5 shadow-sm" data-id="element-83" data-mp="2yy7x1qgx7mx2">
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-rose-50 to-transparent opacity-60" data-id="element-84" data-mp="19inh1x5piixi" />
                <div className="relative flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-rose-100 text-xl" data-id="element-85" data-mp="1e9ned3iqn30j">
                  🩺
                </div>
                <div className="relative" data-id="element-86" data-mp="14jaxpme1ntzo">
                  <p className="text-base font-semibold leading-snug text-ink" data-id="element-87" data-mp="14kcbhymg2ul3">
                    Fighting to reclaim your health
                  </p>
                  <p className="mt-0.5 text-sm italic text-ink-light" data-id="element-88" data-mp="1x7zrf0crsx1e">
                    after the normal system failed you...
                  </p>
                </div>
              </div>

              <div className="relative flex items-start gap-4 overflow-hidden rounded-2xl border border-black/5 bg-white p-5 shadow-sm" data-id="element-89" data-mp="1na21m8f9is6o">
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-teal-50 to-transparent opacity-60" data-id="element-90" data-mp="7s8ncoz198me" />
                <div className="relative flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-teal-100 text-xl" data-id="element-91" data-mp="bw82b34nzzdn">
                  ⚡
                </div>
                <div className="relative" data-id="element-92" data-mp="29jin7zn6ndnz">
                  <p className="text-base font-semibold leading-snug text-ink" data-id="element-93" data-mp="29ktq7x8t0he1">
                    Searching for ways to enhance your looks or performance
                  </p>
                  <p className="mt-0.5 text-sm italic text-ink-light" data-id="element-94" data-mp="1zse72wlrtmrk">
                    beyond what you would normally find...
                  </p>
                </div>
              </div>

              <div className="relative flex items-start gap-4 overflow-hidden rounded-2xl border border-black/5 bg-white p-5 shadow-sm" data-id="element-95" data-mp="1qqer87mhsoq7">
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-amber-50 to-transparent opacity-60" data-id="element-96" data-mp="1gttl1iyql7ks" />
                <div className="relative flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-amber-100 text-xl" data-id="element-97" data-mp="3g762zji4lc5m">
                  🤝
                </div>
                <div className="relative" data-id="element-98" data-mp="3jp3i2twtc1g5">
                  <p className="text-base font-semibold leading-snug text-ink" data-id="element-99" data-mp="3jo27eqjplgyy">
                    Determined to save someone you care about
                  </p>
                  <p className="mt-0.5 text-sm italic text-ink-light" data-id="element-100" data-mp="3sgnakyauxf2o">
                    even if nothing else has worked...
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        <ProofSection data-id="element-101" data-mp="30rk55f78hyog" />
      </div>
    </section>;
}